import React from 'react';
import { AdminHTMLTooltip } from '../styled/HtmlTooltip';
import { useTruncationTooltip } from '../../hooks/useTruncationTooltip/useTruncationTooltip';
import { useTruncatedTextStyles } from './styles';

type TProps = {
  text?: string | null;
  /** Number of visible lines before the value is cut with an ellipsis */
  lines?: number;
  maxWidth?: number | string;
  className?: string;
};

const DEFAULT_LINES = 2;

export const TruncatedText: React.FC<TProps> = ({
  text,
  lines = DEFAULT_LINES,
  maxWidth,
  className,
}) => {
  const { classes, cx } = useTruncatedTextStyles({ lines, maxWidth });
  const { ref, open, onOpen, onClose } = useTruncationTooltip<HTMLSpanElement>();
  const value = text ?? '';

  const content = (
    <span ref={ref} className={cx(classes.text, className)}>
      {value}
    </span>
  );

  if (!value) return content;

  return (
    <AdminHTMLTooltip
      title={<span className={classes.tooltipContent}>{value}</span>}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      placement="top"
    >
      {content}
    </AdminHTMLTooltip>
  );
};
